"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeDirectiveOptionsMenu = void 0;
const react_1 = __importStar(require("react"));
const index_1 = require("../../components/index");
const graphql_zeus_1 = require("graphql-zeus");
const trees_1 = require("../../../../state/containers/trees");
const configureOpts = (node) => {
    let { directiveOptions = [] } = node.type;
    let opts = {};
    Object.keys(graphql_zeus_1.Directive).map((k) => {
        const v = graphql_zeus_1.Directive[k];
        opts[v] = !!directiveOptions.includes(v);
    });
    return opts;
};
exports.NodeDirectiveOptionsMenu = ({ node, hideMenu }) => {
    const { tree, setTree } = trees_1.useTreesState();
    const [opts, setOpts] = react_1.useState(configureOpts(node));
    react_1.useEffect(() => {
        setOpts(configureOpts(node));
    }, [node.type.directiveOptions]);
    return (react_1.default.createElement(index_1.OptionsMenu, { hideMenu: hideMenu, options: opts, onCheck: (o) => {
            var _a, _b;
            const turnOff = !!((_a = node.type.directiveOptions) === null || _a === void 0 ? void 0 : _a.includes(o));
            if (turnOff) {
                node.type.directiveOptions = (_b = node.type.directiveOptions) === null || _b === void 0 ? void 0 : _b.filter((opt) => opt !== o);
            }
            else {
                node.type.directiveOptions = [...(node.type.directiveOptions || []), o];
            }
            setTree(Object.assign({}, tree));
        } }));
};
